import { Component } from '@angular/core';
import { BoobleModalService } from 'booble-modal';


@Component({
  selector: 'app-fatca',
  templateUrl: './fatca.component.html',
  styleUrls: ['./fatca.component.scss']
})
export class FatcaComponent {

  constructor(private modalService: BoobleModalService) { }

  closeModal() {
    this.modalService.dismiss(null);
  }

}
